import { createContext } from 'react';

export type AddSignerCtx = {
  showAddSignerFailError: boolean;
};

const AddSignerContext = createContext<AddSignerCtx>({
  showAddSignerFailError: false,
});

export default AddSignerContext;
